import { useMutation } from "@apollo/client";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useDownloadApiKeyConfig from "shared/ApiKey/useDownloadApiKeyConfig";
import { ApiKey, ApiKeyInput, ApiKeyType } from "types/generated";

import { CREATE_API_KEY } from "./gql";

type UseCreateApiKeyOptions = {
  callback?: (id: string) => void;
};

const useCreateApiKey = ({ callback }: UseCreateApiKeyOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const downloadApiKeyConfig = useDownloadApiKeyConfig();

  const [createApiKey, { loading }] = useMutation<{ apiKeyCreate: ApiKey }>(CREATE_API_KEY);

  const onCreate = (input: ApiKeyInput) => {
    createApiKey({
      variables: {
        input,
      },
    })
      .then(({ data }) => {
        if (data) {
          const {
            apiKeyCreate: { name, id, type, secret },
          } = data;

          if (type === ApiKeyType.Secret) {
            if (!downloadApiKeyConfig({ id, name, secret })) {
              return;
            }
          } else if (type === ApiKeyType.Oidc) {
            reportSuccess({
              message: `API key successfully created`,
            });
          }
          callback?.(id);
        }
      })
      .catch(onError);
  };

  return { onCreate, loading };
};

export default useCreateApiKey;
